import React from "react";
import { Link } from "react-router-dom";

export default function SideMenuItem(props) {
  const { icon, title, type, link } = props;
  return (
    <React.Fragment>
      {type === 2 ? (
        <li className="nav-item">
          <Link className="nav-link" to={link && link}>
            <img
              src={`data:image/png;base64,${icon && icon}`}
              alt="sidemenu_icon"
            />{" "}
            {title && title}
          </Link>
        </li>
      ) : (
        <li className="nav-item">
          <a
            className="nav-link"
            href={link && link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={`data:image/png;base64,${icon && icon}`}
              alt="sidemenu_ico"
            />{" "}
            {title && title}
          </a>
        </li>
      )}
    </React.Fragment>
  );
}
